export { default } from "./BgSection";
